<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
        d="M4.5 15.5H11.5C12.6046 15.5 13.5 14.6046 13.5 13.5V9C13.5 7.89543 12.6046 7 11.5 7H4.5C3.39543 7 2.5 7.89543 2.5 9V13.5C2.5 14.6046 3.39543 15.5 4.5 15.5Z"
        stroke="var(--icon-color)" />
    <path d="M11.5 7V4C11.5 2.067 9.933 0.5 8 0.5V0.5C6.067 0.5 4.5 2.067 4.5 4V7" stroke="var(--icon-color)" />
    <circle cx="8" cy="11" r="1" fill="var(--icon-color)" />
    <path d="M8 10.5L8 13" stroke="var(--icon-color)" />
</svg>
